import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './index.css'
import { applyTheme } from './lib/theme'
import { initSentryClient } from './lib/sentry-client'
import { ErrorBoundary } from './lib/ErrorBoundary'

// Sentry must init BEFORE ReactDOM.createRoot so it can catch render-time errors.
// No-op when VITE_SENTRY_DSN is unset (local dev, etc.) — intentional.
initSentryClient()

registerSW({ immediate: true })
applyTheme()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root missing from index.html')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary component="Root">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
